export default __webpack_public_path__ + "static/Scroll-Image---Residential-Interior-Demolition-56d8bd964057e28ce0801320ce6c3b73.jpg";